import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgDonorRecognitionNotification = (
    props: SVGProps<SVGSVGElement>,
) => (
    <svg
        fill="none"
        height="44"
        width="44"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 44 44"
    >
        <path
            d="M37.4004 44L26.4004 33H4.40039C1.97034 33 0 31.0297 0 28.5996V4.40039C0 1.97034 1.97034 0 4.40039 0H39.5996C42.0297 0 44 1.97034 44 4.40039V28.5996C44 31.0297 42.0297 33 39.5996 33H37.4004V44ZM26.1445 7.7002C24.1806 7.7002 22.8097 9.16578 21.9902 9.90039C21.1707 9.16578 19.7857 7.7002 17.8359 7.7002C14.5159 7.7004 12.0997 9.93457 12.0996 13.791C12.0996 19.932 21.943 25.2735 21.9902 25.2998C21.9902 25.2998 31.8809 19.9434 31.8809 13.791C31.8808 9.9957 29.4647 7.70031 26.1445 7.7002Z"
            fill="white"
        />
    </svg>
);

export const DonorRecognitionNotificationIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgDonorRecognitionNotification}
        fontSize={fontSize}
    />
);
